import { Field, Form, Formik } from "formik";
import { TextField } from "formik-material-ui";
import React, { Fragment, useEffect } from "react";
import * as Yup from "yup";

import {
  Button,
  Divider,
  Grid,
  LinearProgress,
  Toolbar,
  Typography
} from "@material-ui/core";

import { stylesForm, stylesMain } from "../../css";
import { useGetStudent, usePutStudent } from "../../fetch/student";
import useUserStateContext from "../../userstate";
import { withRouter } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";

const StudentNameSchema = Yup.object().shape({
  last_name: Yup.string().required(),
  first_name: Yup.string().required(),
  last_name_kana: Yup.string().required(),
  first_name_kana: Yup.string().required()
});

const StudentDetail = (props: any) => {
  const { classes } = props;
  const { userState } = useUserStateContext();
  const { student, getStudent } = useGetStudent();
  const { putStudent } = usePutStudent();

  useEffect(() => {
    userState.signedIn === false && props.history.push("/login");
    getStudent({ studentId: props.match.params.studentId });
  }, [userState, props.history]);

  return (
    <Fragment>
      <main className={classes.main}>
        <Toolbar>
          <Grid justify="space-between" container>
            <Grid item>
              <Typography component="h1" variant="h6">
                Student Detail
              </Typography>
            </Grid>
            <Grid item></Grid>
          </Grid>
        </Toolbar>
        <Divider />
        <div className={classes.form}>
          <Formik
            initialValues={{
              last_name: student.last_name ? student.last_name : "",
              first_name: student.first_name ? student.first_name : "",
              last_name_kana: student.last_name_kana
                ? student.last_name_kana
                : "",
              first_name_kana: student.first_name_kana
                ? student.first_name_kana
                : ""
            }}
            enableReinitialize
            validationSchema={StudentNameSchema}
            onSubmit={async value => {
              await putStudent({
                studentId: props.match.params.studentId,
                body: value
              });
              await getStudent({ studentId: props.match.params.studentId });
            }}
            render={({ submitForm, isSubmitting }) => (
              <Form>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Field
                      margin="dense"
                      name="last_name"
                      type="text"
                      label="姓"
                      component={TextField}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Field
                      margin="dense"
                      name="first_name"
                      type="text"
                      label="名"
                      component={TextField}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Field
                      margin="dense"
                      name="last_name_kana"
                      type="text"
                      label="セイ"
                      component={TextField}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Field
                      margin="dense"
                      name="first_name_kana"
                      type="text"
                      label="メイ"
                      component={TextField}
                      fullWidth
                    />
                  </Grid>
                </Grid>

                <Grid container justify="flex-end">
                  <Grid item>
                    <Button
                      className={classes.button}
                      variant="contained"
                      color="primary"
                      disabled={isSubmitting}
                      onClick={submitForm}
                    >
                      Save
                    </Button>
                  </Grid>
                </Grid>
                {isSubmitting && <LinearProgress />}
              </Form>
            )}
          />

          <p className={classes.studentDetail}>
            {JSON.stringify(student, null, "\t")}
          </p>
        </div>
      </main>
    </Fragment>
  );
};

export default withStyles(stylesMain)(
  withStyles(stylesForm)(withRouter(StudentDetail))
);
